export default __webpack_public_path__ + "static/media/ikon-panah-bawah.1839aec2.svg";